import React from "react";
import withSvgIcon from "~/hocs/with-svg-icon";

export const UpArrowIcon = withSvgIcon(
    <g>
        <polygon points="439.4,313.3 250,123.8 60.6,313.2 32.3,284.9 250,67.3 467.7,285" />
    </g>
);
